export default __webpack_public_path__ + "static/logo-4a008be84353bae1d9064be64584f5ea.svg";